import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from 'redux/use-hooks';
import { Button, ButtonsGrid } from 'components/common/button/button';
import { useModal } from '../context';
import { connectWalletAndResolveAccess } from 'utils/connect-wallet-and-resolve-access';
import { StyledContainer, StyledSection, StyledHeading } from './views.style';

const AccessView = ({ closeModal }: { closeModal: () => void }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { openModal } = useModal();
  const [isLoading, setIsLoading] = useState(false);

  const handleConnect = async () => {
    setIsLoading(true);
    try {
      await connectWalletAndResolveAccess({
        dispatch,
        openModal,
        closeModal,
        navigate,
        forceConnect: true
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <StyledContainer>
      <StyledSection p="36px 48px 48px">
        <StyledHeading>
          <b>
            Connect your Meteor Wallet account to link it to the OFP Wallet
          </b>
        </StyledHeading>
        <ButtonsGrid gridGap={20}>
          <Button
            disabled={isLoading}
            type="button"
            fullwidth
            onClick={handleConnect}
          >
            Connect Meteor Wallet
          </Button>
          <Button
            fullwidth
            variant="secondary"
            type="button"
            onClick={closeModal}
            disabled={isLoading}
          >
            Cancel
          </Button>
        </ButtonsGrid>
      </StyledSection>
    </StyledContainer>
  );
};

export default AccessView;
